import React from 'react';

var Carousel = props => {
  return (
    <div className="all-carousel">
      <div id="carouselExampleIndicators" className="carousel slide" data-ride="carousel" data-interval="10000">
      <ol className="carousel-indicators">
        <li data-target="#carouselExampleIndicators" data-slide-to="0" className="active"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
        {
        //<li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
        }
      </ol>
      <div className="carousel-inner" role="listbox">
        {// <div className="carousel-item active">
        //   <img className="d-block img-fluid" src="./img/survey-1.jpg" alt="First slide" style={{width: "100%"}}/>
        //   <div className="container">
        //     <div className="row">
        //       <div className="offset-md-4 col-md-8">
        //         <div className="carousel-caption">
        //           <div className="carousel-foundation">
        //             <h1>Walter M. Cunningham Education Foundation</h1>
        //             <p>Pellentesque pharetra velit nec aliquet condimentum. Vestibulum tincidunt maximus nunc, sed congue lacus. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Etiam gravida magna vitae diam mollis, et tincidunt orci vehicula.</p>
        //             <a className="carousel-button" href="#">Learn more</a>
        //           </div>
        //         </div>
        //       </div>
        //     </div>
        //   </div>
        //</div>
      }
        
        <div className="carousel-item active">
          <img className="d-block img-fluid" src="./img/frary-peak.jpg" alt="First slide" style={{width: "100%"}}/>
          <div className="container">
            <div className="row">
              <div className="container">
                <div className="carousel-caption vert-outer">
                  <div className="vert-inner"> 
                    {
                      //<h1>Walter M. Cunningham Education Foundation</h1>
                    }
                    <p>"I would not have been able to pursue my education without the scholarships.  They have been vital in enabling me to focus on my studies so I can achieve my career goals and support my family." Sean Ireland</p>
                    {
                      //<a className="carousel-button" href="#">Learn more</a>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="carousel-item">
          <img className="d-block img-fluid" src="./img/bees.jpg" alt="Second slide" style={{width: "100%"}}/>
          <div className="container">
            <div className="row">
              <div className="container">
                <div className="carousel-caption vert-outer">
                  <div className="vert-inner">
                    {
                      //<h1>Donate</h1>
                    }
                    <p>"Scholarships have freed my mind from worrying about paying for school and have allowed me to focus on becoming what I want to be."   Mike Stewart</p>
                    {
                      //<a className="carousel-button" href="/donate">Donate</a>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {
        /*
        <div className="carousel-item">
          <img className="d-block img-fluid" src="./img/survey-3-crop-swap.jpg" alt="Third slide" style={{width: "100%"}}/>
            <div className="container">
              <div className="row">
                <div className="container">
                  <div className="carousel-caption vert-outer">
                    <div className="vert-inner">
                      {
                        //<h1>Scholarship</h1>
                      }
                      <p>Nullam maximus porttitor est, fermentum tempus elit consectetur vitae. Pellentesque pharetra velit nec aliquet condimentum. Vestibulum tincidunt maximus nunc, sed congue lacus. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Etiam gravida magna vitae diam mollis, et tincidunt orci vehicula.</p>
                      {
                        //<a className="carousel-button" href="/scholarship">Apply</a>
                      }
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
        */
        }
      <a className="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="sr-only">Previous</span>
      </a>
      <a className="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="sr-only">Next</span>
      </a>
    </div>
    </div>
    </div>
    )
};


export default Carousel;



// WEBPACK FOOTER //
// ./src/components/Carousel.js